// Control for temporarily unmasking sensitive data
rs.module("controls/data/masked-data",

	// dependencies
	[],

	function () {

		var _backendUrl;
		var _styledBullet;

		// Initialize 
		function initialize(selectors, cssClasses, backendUrl, durationSeconds) {
			_backendUrl = backendUrl;
			_styledBullet = cssClasses.styledBullet;

			$(document).onjs("click", selectors._maskedData, function (event) {
				// don't let the click bubble up
				event.stopPropagation();
				event.preventDefault();

				// save the masked value for replacing later
				var maskSpan = $(this);

                // capture current width then force it to not get smaller 
                var width = $(maskSpan).width();
                $(maskSpan).css('min-width', `${width}px`);

				// don't repeat trying to unmask if we're already unmasked
				if (maskSpan.hasClass(cssClasses._unmaskedClass)) {
					return;
				}

				var maskedValue = maskSpan.html();

				$.post(_backendUrl, { encrypted: maskSpan.data("value") }).done(function (result) {
					maskSpan.addClass(cssClasses._unmaskedClass);

					maskSpan.fadeOut('fast', function () {
						maskSpan.html(result.data).fadeIn('fast');
					});

					var timeout = durationSeconds * 1000;
					setTimeout(reMaskIfNotHovered, timeout);

					/// Re-masks the data so long as the cursor isn't on the element.  If it is, 
					// initiates another wait.
					function reMaskIfNotHovered() {
						// if the mouse is over the element, wait more
						if (maskSpan.is(":hover")) {
							setTimeout(reMaskIfNotHovered, timeout);
						}
						else {
							// put the masked value back
							maskSpan.removeClass(cssClasses._unmaskedClass);
							maskSpan.fadeOut('fast', function () {
								maskSpan.html(maskedValue).fadeIn('fast');
                                maskSpan.css('min-width', 'auto');
							});
						}
					}
				});
            });
		}

		// Swap out the bullets in the given text for styled bullets
		function applyBulletStyling(text) {
			return text.replaceAll("●", _styledBullet);
		}

		var exports = {
			initialize: initialize,
			applyBulletStyling: applyBulletStyling
		};

		return exports;
	}
);